export { default } from './CustomCodeConsentNewContent';
